import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Breadcrumbs from '../../../layout/components/Breadcrumbs';
import UploadFileModal from '../../../components/UploadFileModal/UploadFileModal';
import Button from '../../../components/Button/Button';
import ButtonTypes from '../../../constants/buttonTypes';
import { IconFileImport } from '../../../assets/icon';

const containerClassName = [
  'flex flex-col sm:flex-row sm:items-center gap-[10px]',
  'border-t border-[#eff2f5] dark:border-[#1b263b] px-[16px] sm:px-[25px] h-full'
].join(' ');
const breadcrumbsClassName = 'py-[5px]';
const buttonClassName = 'px-[13px] py-[8px] w-full sm:w-auto';

const CompatibilitySubheader = () => {
  const navigate = useNavigate();

  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const breadcrumbs = {
    pageTitle: 'Compatibility',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'Compatibility',
      },
    ]
  };

  return (
    <div className={containerClassName}>
      <div className="flex-1">
        <div className="flex flex-row items-center">
          <Breadcrumbs breadcrumbs={breadcrumbs} containerStyle={breadcrumbsClassName} />
        </div>
      </div>
      <div className="flex flex-row justify-end">
        <Button
          type={ButtonTypes.LIGHT}
          icon={<IconFileImport />}
          containerStyle={buttonClassName}
          tooltip="Click to upload"
          tooltipId="coOrderExportTable"
          onClick={() => setUploadModalVisible(true)}
        />
      </div>
      <UploadFileModal
        visible={uploadModalVisible}
        toggleVisible={() => setUploadModalVisible(false)}
      />
    </div>
  );
};

CompatibilitySubheader.propTypes = {};

CompatibilitySubheader.defaultProps = {};

export default CompatibilitySubheader;
